// extracted by mini-css-extract-plugin
export default {"wrap":"Fw-z","fullWidth":"Gw-z","searchPlacement":"Hw-z","items":"Iw-z","featureCss":"Jw-z","disabled":"Kw-z","imgCss":"Lw-z"};